import { render, staticRenderFns } from "./peatonalManual.vue?vue&type=template&id=799188b4&scoped=true&"
import script from "./peatonalManual.vue?vue&type=script&lang=js&"
export * from "./peatonalManual.vue?vue&type=script&lang=js&"
import style0 from "./peatonalManual.vue?vue&type=style&index=0&id=799188b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799188b4",
  null
  
)

export default component.exports